import { TIbexPricingDetails } from '../types/module/window';
import { Product } from '../types/generatedContent';
import { IIbexPricingDetail } from '../types/subscription';

export type TFoundSubscription = {
  subscription: IIbexPricingDetail | undefined;
  isOneMonth: boolean;
};

const findCurrentSubscription = (
  ibexPricingDetails: TIbexPricingDetails,
  products: Product[],
  planProductKey: string
): TFoundSubscription => {
  const foundSubscription = ibexPricingDetails.subscriptions.find((sub) => {
    return products.find((product) => {
      return product.type === planProductKey ? product.ids.find((id) => id === sub.id) : false;
    });
  });
  return {
    subscription: foundSubscription,
    isOneMonth: planProductKey === 'oneMonth',
  };
};

export default findCurrentSubscription;
